/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ErrorResponse, PlantDTO } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class PlantApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags plant-api
   * @name GetAllPlants
   * @request GET:/api/plants
   * @secure
   */
  getAllPlants = (params: RequestParams = {}) =>
    this.request<PlantDTO[], ErrorResponse>({
      path: `/api/plants`,
      method: "GET",
      secure: true,
      ...params,
    });
}
